import { useState } from "react";
import ScrollReveal from "../../../components/feature/ScrollReveal";

interface Testimonial {
  name: string;
  age: string;
  scene: string;
  date: string;
  rating: number;
  title: string;
  short: string;
  full: string;
  image: string;
}

const testimonials: Testimonial[] = [
  {
    name: "K・Y様",
    age: "30代",
    scene: "結婚記念日",
    date: "2025.04",
    rating: 5,
    title: "結婚3周年の記念に、思い出に残る体験を",
    short:
      "結婚記念日に利用しました。みなとみらいの夜景を空から見た瞬間、感動で言葉が出ませんでした。",
    full:
      "結婚3周年の記念に、いつもと違う特別な体験がしたいと思い、AIRDOAの横浜ヘリクルージングを予約しました。当日はお天気も良く、ベイブリッジや赤レンガ倉庫、ランドマークタワーが目の前に広がり、地上では絶対に見られない景色に夫婦二人で息を飲みました。パイロットの方もとても親切で、見どころのポイントで「こちらから見えますよ」と声をかけてくれました。帰りは記念撮影のデータが届き、またあの景色を思い出しては二人で笑顔になります。サービス全体が洗練されていて、高級感がありました。次の記念日も絶対に予約します。",
    image:
      "https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20Yokohama%20Minato%20Mirai%20district%20seen%20from%20inside%20helicopter%20cabin%2C%20romantic%20atmosphere%2C%20sparkling%20city%20lights%2C%20deep%20navy%20sky%2C%20no%20text&width=400&height=300&seq=rv01&orientation=landscape",
  },
  {
    name: "H・O様",
    age: "30代",
    scene: "プロポーズ",
    date: "2025.02",
    rating: 5,
    title: "夜景の前で、最高のプロポーズができました",
    short:
      "プロポーズのサポートをお願いしました。夜景の前での指輪の準備など、スタッフが細かく手伝ってくれました。",
    full:
      "人生で一番緊張した日でした。AIRDOAに事前にプロポーズの相談をしたところ、機内での指輪の準備やタイミングの取り方まで、スタッフが一緒にプランを立ててくれました。当日、ベイブリッジが目の前に迫ってきた瞬間、彼女が「きれい…」と呟いたそのタイミングで指輪を見せました。彼女は驚いて、そして感動で泣いてくれて、最高の答えをもらいました。パイロットも私たちのために少し旋回してくれて、時間を稼いでくれた気がします。あの夜空と彼女の笑顔は、一生の思い出です。本当にありがとうございました。",
    image:
      "https://readdy.ai/api/search-image?query=Night%20aerial%20view%20of%20Yokohama%20harbor%20with%20sparkling%20city%20lights%20from%20helicopter%2C%20romantic%20proposal%20moment%20concept%2C%20deep%20navy%20sky%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv04&orientation=landscape",
  },
  {
    name: "A・T様",
    age: "40代",
    scene: "誕生日サプライズ",
    date: "2025.03",
    rating: 5,
    title: "妻の誕生日に、サプライズで夕景コースを",
    short:
      "妻への誕生日サプライズで利用しました。夕景コースにしたのですが、日没から夜景へ変わる瞬間が美しく、妻も大満足でした。",
    full:
      "毎年、妻の誕生日には何か特別なことをしたいと考えています。今年はAIRDOAの夕景コースをギフトチケットとして購入し、当日まで秘密にしていました。ヘリポートに到着した時、妻は「え、本当に？」と驚いた顔でしたが、機体に近づくにつれ、子供のように目を輝かせていました。夕景コースにして正解でした。日が沈む瞬間から、みなとみらいのライトが次々と点灯していく様子は、まるで魔法のようでした。妻は「来年もこれがいい」と言っています。スタッフの対応も素晴らしく、また利用したいと思います。",
    image:
      "https://readdy.ai/api/search-image?query=Sunset%20transitioning%20to%20night%20aerial%20view%20over%20Yokohama%20bay%2C%20warm%20orange%20and%20deep%20navy%20gradient%20sky%2C%20helicopter%20tour%20experience%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv03&orientation=landscape",
  },
  {
    name: "S・M様",
    age: "20代",
    scene: "デート",
    date: "2025.03",
    rating: 5,
    title: "初めてのヘリコプター、彼女も大満足",
    short:
      "初めてのヘリコプターでしたが、スタッフが丁寧に案内してくれたので全く不安はありませんでした。彼女も大喜びでした。",
    full:
      "デートのメインイベントとしてヘリコプター遊覧を計画しました。正直、自分も彼女もヘリコプターに乗るのは初めてで、少し不安でした。でも、AIRDOAのサイトに載っていた「初めての方へ」のページを事前に読んで、当日の流れを把握できたので安心感がありました。受付で安全説明を受けた後、パイロットが「今日は気持ちのいい日ですね」と声をかけてくれて、緊張がほぐれました。ベイブリッジが目前に迫ってきた時は、彼女が「すごい！」と叫んで、手を握ってくれました。あの瞬間、最高のデートだと確信しました。記念撮影の写真もSNSにあげたら、友人から大量の「え、何それ！？」のコメントが来ました。",
    image:
      "https://readdy.ai/api/search-image?query=Illuminated%20Yokohama%20Bay%20Bridge%20aerial%20view%20at%20night%20from%20helicopter%2C%20deep%20navy%20sky%2C%20sparkling%20lights%2C%20romantic%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=400&height=300&seq=rv02&orientation=landscape",
  },
];

export default function TestimonialsSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-24 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">VOICE</p>
              <h2 className="section-title">お客様の体験談</h2>
              <p className="mt-3 text-sm text-airdoa-gray leading-relaxed max-w-2xl mx-auto">
                実際にAIRDOAで横浜ヘリクルージングを体験いただいたお客様からの感想をご紹介します。
              </p>
            </div>
          </ScrollReveal>

          <div className="flex flex-col gap-6">
            {testimonials.map((t, idx) => {
              const isExpanded = expandedIdx === idx;
              return (
                <ScrollReveal key={t.name} direction="up" delay={idx * 80}>
                  <div className="bg-white rounded-lg overflow-hidden border border-airdoa-gray-light/30">
                    <div className="flex flex-col md:flex-row">
                      <div className="md:w-48 lg:w-56 shrink-0">
                        <img
                          src={t.image}
                          alt={t.scene}
                          className="w-full h-48 md:h-full object-cover object-top"
                        />
                      </div>
                      <div className="p-5 md:p-6 flex-1 flex flex-col">
                        <div className="flex items-center gap-1 mb-2">
                          {Array.from({ length: t.rating }).map((_, i) => (
                            <span
                              key={i}
                              className="w-4 h-4 flex items-center justify-center text-airdoa-gold"
                            >
                              <i className="ri-star-fill text-sm" />
                            </span>
                          ))}
                        </div>
                        <h3 className="text-sm md:text-base font-serif font-semibold text-airdoa-navy leading-snug mb-2">
                          {t.title}
                        </h3>
                        <p
                          className={`text-sm text-airdoa-gray leading-relaxed ${
                            isExpanded ? "" : "line-clamp-3"
                          }`}
                        >
                          {isExpanded ? t.full : t.short}
                        </p>
                        <button
                          onClick={() =>
                            setExpandedIdx(isExpanded ? null : idx)
                          }
                          className="mt-2 text-xs font-medium text-airdoa-gold hover:text-airdoa-navy transition-colors self-start cursor-pointer"
                        >
                          {isExpanded ? "閉じる" : "続きを読む"}
                        </button>
                        <div className="mt-auto pt-4 border-t border-airdoa-gray-light/30 flex items-center justify-between">
                          <div>
                            <p className="text-sm font-medium text-airdoa-navy">
                              {t.name}
                            </p>
                            <p className="text-xs text-airdoa-gray">
                              {t.age} / {t.date}
                            </p>
                          </div>
                          <span className="px-2 py-1 text-[10px] font-medium text-airdoa-gold bg-airdoa-cream rounded">
                            {t.scene}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}